import React, { useCallback } from 'react';
import Distance from '../../styled/Distance';
import { CheckIcon } from '../../styled/Icon';

import { ValueButton, TextContainer, Action, Value, Help } from '../../styled/ValueButton/wrappers';
import clsx from 'clsx';
import { IItemBase, ItemId } from './types';

interface IItemProps<TId extends ItemId, TItem extends IItemBase<TId>> {
  active: boolean;
  item: TItem;
  onSelect: (id: TId) => void;
  renderStatus?: (item: TItem) => JSX.Element;
  selectable?: boolean;
  disableBubbling?: boolean;
}

const ItemPanelItem = <TItemId extends ItemId, TItem extends IItemBase<TItemId>>({
  active,
  onSelect,
  item,
  renderStatus,
  selectable,
  disableBubbling,
}: IItemProps<TItemId, TItem>) => {
  const click = useCallback(() => {
    onSelect(item.id);
  }, [onSelect, item.id]);

  return (
    <ValueButton className={clsx(active && 'active', 'padding-none')} key={item.id}>
      <TextContainer>
        <Value>{item.name}</Value>
        <Help>
          {!!renderStatus && (
            <>
              <Distance size="half" />
              {renderStatus(item)}
            </>
          )}
        </Help>
      </TextContainer>
      {active && (
        <Action className={clsx(disableBubbling && 'prevent-bubbling')}>
          <>
            Vald <CheckIcon className="m-l-half" />
          </>
        </Action>
      )}
      {selectable && !active && (
        <Action onClick={click} className={clsx(disableBubbling && 'prevent-bubbling')}>
          Välj
        </Action>
      )}
    </ValueButton>
  );
};

export default ItemPanelItem;
